const QuantityInput = (props) => {
  const { quantity, onQuantityChange, product, errorMessage } = props;
  let minQty = 0;
  let maxQty = 1000;
  if (
    product.security &&
    product.security.availableTo === 'Allocation' &&
    product.allocations &&
    product.allocations[0]
  ) {
    minQty = product.allocations[0].minQuantity;
    maxQty =
      product.allocations[0].maxQuantity +
      product.allocations[0].additionalGrant -
      product.allocations[0].quantityPurchased;
  }
  if (maxQty - minQty < 0) {
    return null;
  }

  const handleQuantity = (e) => {
    const input = e.target.value;
    const qty = input.replace(/[^0-9]/g, '');
    onQuantityChange(qty);
  };
  let describedby;
  if (errorMessage) {
    describedby = { 'aria-describedby': 'qtyerror' };
  }
  if (maxQty - minQty <= 24) {
    const optionArray = [];
    for (let i = minQty; i <= maxQty; i += 1) {
      optionArray.push(i);
    }
    return (
      <label htmlFor="quantity">
        <select
          name="quantity"
          className="c7-product__variant__add-to-cart__select"
          value={quantity}
          onChange={handleQuantity}
          aria-label={`Quantity for ${product.title}`}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...describedby}
        >
          {optionArray.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </label>
    );
  }

  return (
    <label htmlFor="quantity">
      <input
        type="text"
        name="quantity"
        value={quantity}
        onChange={handleQuantity}
        inputMode="numeric"
        aria-label={`Quantity for ${product.title}`}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...describedby}
      />
    </label>
  );
};

export default QuantityInput;
